/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const r={linear:0,rectangular:1,circular:2},e={isAbsolute:0,isDiscrete:1};export{e as bitset,r as gradientFillMethods};
